<template>
  <div>
    <el-form ref="form" :model="curInput" :rules="rules" label-width="100px" v-loading="loading">
      <el-form-item label="仅允许一个人员">
        <el-radio-group v-model="curInput.people.select_type">
          <el-radio :label="10">是</el-radio>
          <el-radio :label="20">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="选择范围">
        <el-radio-group v-model="curInput.people.select_range">
          <el-radio :label="10">不限</el-radio>
          <el-radio :label="20" disabled>用户所属部门人员</el-radio>
          <el-radio :label="30" disabled>用户下级</el-radio>
          <el-radio :label="40">自定义</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="已选人员">
        <div v-show="unlimit">不限</div>
        <div v-show="rangeCustom">
          <el-tag class="m-l-5" v-for="people in selectedPeople" :close-transition="true" :closable="true" type="primary" @close="handleCloseRange(people)">
            {{people.realname}}
          </el-tag>
        </div>
      </el-form-item>
      <el-form-item label="默认选中值">
        <el-radio-group v-model="curInput.people.select_default">
          <el-radio :label="1">无</el-radio>
          <el-radio :label="2">用户</el-radio>
          <el-radio :label="3" disabled>用户上级</el-radio>
          <el-radio :label="4">自定义</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="已选默认人员">
        <div v-show="nothing">无</div>
        <div v-show="user">用户</div>
        <div v-show="superior">用户上级</div>
        <div v-show="defaultCustom">
          <el-tag class="m-l-5" v-for="defaulter in selectedDefault" :close-transition="true" :closable="true" type="primary" @close="handleCloseDefault(defaulter)">
            {{defaulter.realname}}
          </el-tag>
        </div>
        <div v-show="singleSelect">
          <el-select v-model="singleDefault" placeholder="请选择" @change="getDefaultSelection">
            <el-option
              v-for="item in selectedPeople"
              :label="item.realname"
              :value="item.user_id">
            </el-option>
          </el-select>
        </div>
        <div v-show="multiSelect">
          <el-select v-model="multiDefault" multiple placeholder="请选择" @change="getMultiDefaultSelection">
            <el-option
              v-for="item in selectedPeople"
              :label="item.realname"
              :value="item.user_id">
            </el-option>
          </el-select>
        </div>
      </el-form-item>
      <!-- <el-form-item>
        <el-button type="primary" @click="onSubmit">log data</el-button>
      </el-form-item> -->
    </el-form>
    <range-select :dialogShow="rangeDialog" :title="rangeTitle" :selectedIds="selectedRangeIds" :selectedPeople="selectedPeople" :structData="structs" @closeDialog="closeRangeDialog"></range-select>
    <default-select :dialogShow="defaultDialog" :title="defaultTitle" :selectedIds="selectedDefaultIds" :isOnly="curInput.people.select_type" :selectedPeople="selectedDefault" :structData="structs" @closeDialog="closeDefaultDialog" @beforeSingleChange="clearData"></default-select>
  </div>
</template>
<script>
  import rangeSelect from './peopleSelect.vue'
  import defaultSelect from './peopleSelect.vue'
  import http from '../../../assets/js/http'

  export default {
    props: ['curInput'],
    data() {
      return {
        rangeTitle: '选择范围',
        defaultTitle: '选择默认人员',
        rangeDialog: false,
        defaultDialog: false,
        inputChange: false,
        singleDefault: null,          // 单选默认人员字符串
        structs: [],                  // 部门数据
        multiDefault: [],             // 多选默认人员数组
        selectedRangeIds: [],         // 选择范围已选人员ids
        selectedPeople: [],           // 选择范围已选人员
        selectedDefaultIds: [],       // 已选默认人员ids
        selectedDefault: []           // 已选默认人员
      }
    },
    methods: {
      onSubmit() {
        console.log('selectedPeople = ', _g.j2s(this.selectedPeople))
      },
      closeRangeDialog() {
        this.rangeDialog = false
        this.assignPeopleOption(this.selectedRangeIds, 'range')
      },
      closeDefaultDialog() {
        this.defaultDialog = false
        this.assignPeopleOption(this.selectedDefaultIds, 'default')
      },
      assignPeopleOption(data, type) {
        // 每当自定义弹窗关闭时，构建 curInput.people_option 数组
        let temp = {}
        _(data).forEach((res) => {
          temp.user_id = res
          if (type == 'default') {
            temp.is_selected = 1
          } else {
            temp.is_selected = 0
          }
          this.curInput.people_option.push(temp)
          temp = {}
        })
      },
      handleCloseRange(tag) {
        // 删除已选选择范围人员
        const index = this.selectedPeople.indexOf(tag)
        const index_ = this.selectedRangeIds.indexOf(tag.user_id)
        this.selectedPeople.splice(index, 1)
        this.selectedRangeIds.splice(index_, 1)
        this.curInput.people_option.splice(index, 1)
      },
      handleCloseDefault(tag) {
        // 删除已选默认人员
        const index = this.selectedDefault.indexOf(tag)
        const index_ = this.selectedDefaultIds.indexOf(tag.user_id)
        this.selectedDefault.splice(index, 1)
        this.selectedDefaultIds.splice(index_, 1)
        this.curInput.people_option.splice(index, 1)
      },
      clearData() {
        // 清空数据，由子组件 default-select 单选默认人员时触发，在选择新的默认人员前先清空原有数据
        this.selectedDefaultIds = []
        this.selectedDefault = []
      },
      getDefaultSelection(val) {
        // 单选默认人员选择完成后改变 curInput.people_option 的值
        _(this.curInput.people_option).forEach((res) => {
          res.is_selected = 0
          if (res.user_id == val) {
            res.is_selected = 1
          }
        })
      },
      getMultiDefaultSelection() {
        // 多选默认人员每次选择完成后执行，改变 curInput.people_option 的值
        _(this.curInput.people_option).forEach((res) => {
          res.is_selected = 0
          _(this.multiDefault).forEach((res1) => {
            if (res.user_id == res1) {
              res.is_selected = 1
            }
          })
        })
      },
      getStructs() {
        if (!this.structs.length) {
          this.apiGet('admin/structures').then((res) => {
            if (res.code == 200) {
              this.structs = res.data
            } else {
              _g.dealError(this, res)
            }
          })
        }
      },
      initRangeData() {
        // 初始化选择范围人员数据，编辑时执行，添加不执行
        this.selectedPeople = this.curInput.people_data
        _(this.selectedPeople).forEach((res) => {
          this.selectedRangeIds.push(res.user_id)
        })
      },
      initDefaultData() {
        // 初始化默认人员数据，编辑时执行，添加不执行
        if (this.curInput.people.select_type == 10 && this.curInput.people.select_range == 40 && this.curInput.people.select_default == 4) {
          // 单选、选择范围自定义、默认选中人员自定义情况，初始化单选默认人员字符串的值
          _(this.curInput.people_data).forEach((res) => {
            if (res.is_selected == 1) {
              this.singleDefault = res.user_id
            }
          })
        } else if (this.curInput.people.select_type == 20 && this.curInput.people.select_range == 40 && this.curInput.people.select_default == 4) {
          // 多选、选择范围自定义、默认选中人员自定义情况，初始化多选默认人员数组的值
          _(this.curInput.people_data).forEach((res) => {
            if (res.is_selected == 1) {
              this.multiDefault.push(res.user_id)
            }
          })
        } else if ((this.curInput.people.select_type == 10 && this.curInput.people.select_range == 10 && this.curInput.people.select_default == 4) || (this.curInput.people.select_type == 20 && this.curInput.people.select_range == 10 && this.curInput.people.select_default == 4)) {
          // 单选或多选、选择范围不限，默认选中人员自定义情况，初始化已选默认人员ids、已选默认人员的值
          _(this.curInput.people_data).forEach((res) => {
            if (res.is_selected == 1) {
              this.selectedDefault.push(res)
              this.selectedDefaultIds.push(res.user_id)
            }
          })
        }
      },
      setInputChange(value) {
        this.inputChange = value
      }
    },
    computed: {
      unlimit() {
        return this.curInput.people.select_range == 10
      },
      rangeCustom() {
        return this.curInput.people.select_range == 40
      },
      nothing() {
        return this.curInput.people.select_default == 1
      },
      user() {
        return this.curInput.people.select_default == 2
      },
      superior() {
        return this.curInput.people.select_default == 3
      },
      defaultCustom() {
        return this.curInput.people.select_default == 4
      },
      singleSelect() {
        return this.curInput.people.select_type == 10 && this.curInput.people.select_range == 40 && this.curInput.people.select_default == 4
      },
      multiSelect() {
        return this.curInput.people.select_type == 20 && this.curInput.people.select_range == 40 && this.curInput.people.select_default == 4
      }
    },
    mounted() {
      if (this.curInput.people_data && this.curInput.people_data.length) {
        this.initRangeData()
        this.initDefaultData()
      }
      this.getStructs()
    },
    watch: {
      'curInput'() {
        this.setInputChange(true)
      },
      'curInput.people.select_type'() {
        // if (this.inputChange) {
        //   return
        // }
        // 单选、多选切换时，重置 select_default 的值
        this.curInput.people.select_default = 1
      },
      'curInput.people.select_range'() {
        if (this.inputChange) {
          return
        }
        // 选择范围切换时，重置 select_default 的值
        this.curInput.people.select_default = 1
        if (this.curInput.people.select_range == 10) {
          this.selectedRangeIds = []
          this.selectedPeople = []
        }
        if (this.curInput.people.select_range == 40) {
          this.rangeDialog = true
        } else {
          this.rangeDialog = false
        }
      },
      'curInput.people.select_default'() {
        // if (this.inputChange) {
        //   return
        // }
        console.log('default change')
        // 默认选中值切换情况
        if (this.curInput.people.select_default != 4) {
          // 如果切换不是自定义，重置以下4个数组
          // this.curInput.people_option = []
          this.selectedDefaultIds = []
          this.selectedDefault = []
          this.multiDefault = []
        }
        if (this.curInput.people.select_default == 4) {
          // 切换到自定义，如果是单选，则打开弹窗选择
          if (this.curInput.people.select_range == 10) {
            this.defaultDialog = true
          }
          if (!this.curInput.people_option.length && this.selectedPeople.length) {
            // 当 curInput.people_option.length 不为空（编辑、或已经选择过默认人员），且选择范围为自定义且已有数据。需要根据选择范围的数据重新构造 curInput.people_option 的值
            let temp = {}
            _(this.selectedPeople).forEach((res) => {
              temp.user_id = res.user_id
              temp.is_selected = 0
              this.curInput.people_option.push(temp)
              temp = {}
            })
          }
        }
      },
      'inputChange'() {
        if (this.inputChange) {
          this.setInputChange(false)
        }
      }
    },
    components: {
      rangeSelect,
      defaultSelect
    },
    mixins: [http]
  }
</script>


// WEBPACK FOOTER //
// peopleConfig.vue?0a887c22